import i18n from "../i18n";

const Widgets = (app) => {
  app
    // Create or update a widget
    .post("/widgets/save/:widget?", async ({ req, res, flash, api }) => {
      const { body, params } = req;
      const { widget } = params;
      let widgetToSelect = widget;
      let typeToSelect = "";
      if (!widget) {
        const res = await api("widget", {
          method: "POST",
          body,
        });

        const saved = await res.json();

        if (saved && saved._id) {
          widgetToSelect = saved._id;
          typeToSelect = saved.type;
        }

        flash(
          "success",
          i18n.t("coaching-portal:widgetsActions.successfullyCreated")
        );
      } else {
        await api(`widget/${widget}`, {
          method: "PUT",
          body,
        });
        flash(
          "success",
          i18n.t("coaching-portal:widgetsActions.successfullyUpdated")
        );
      }

      if (widget) {
        return res.refreshWith(
          { widget: widgetToSelect || "", modal: "", widgetModal: "" },
          { url: "back", hash: "#_" }
        );
      } else {
        return res.refreshWith(
          {
            widget: widgetToSelect,
            modal: "",
            widgetModal: "",
            section: "manager",
            tab: "manager-tab",
            type: typeToSelect,
          },
          { url: "back", hash: "#_" }
        );
      }
    })
    .get("/widgets/publish/:id", async ({ api, assert, res, req, flash }) => {
      const { id } = req.params;
      assert(
        id,
        400,
        i18n.t("coaching-portal:widgetsActions.widgetIdRequired")
      );

      try {
        await api("widget-publish", {
          method: "PUT",
          body: { id },
        });
        flash(
          "success",
          i18n.t("coaching-portal:widgetsActions.successfullyPublished")
        );
        res.refreshWith({}, { url: "back" });
      } catch (e) {
        flash("error", e.message);
        res.refreshWith({}, { url: "back" });
      }
    })
    .get("/widgets/unpublish/:id", async ({ api, assert, res, req, flash }) => {
      const { id } = req.params;
      assert(
        id,
        400,
        i18n.t("coaching-portal:widgetsActions.widgetIdRequired")
      );

      try {
        await api("widget-unpublish", {
          method: "PUT",
          body: { id },
        });
        flash(
          "success",
          i18n.t("coaching-portal:widgetsActions.successfullyUnpublished")
        );
        res.refreshWith({}, { url: "back" });
      } catch (e) {
        flash("error", e.message);
        res.refreshWith({}, { url: "back" });
      }
    })

    .post("/widgets/reorder", async ({ api, assert, flash, req, res }) => {
      const { body } = req;
      assert(
        body.orderedWidgets,
        400,
        i18n.t("coaching-portal:widgetsActions.provideOrderedWidgets")
      );

      await api("widget-reorder", {
        method: "PUT",
        body,
      }).then((res) => console.log("res==", res));

      flash(
        "success",
        i18n.t("coaching-portal:widgetsActions.successfullyReordered")
      );
      res.backDontScroll();
    })

    .post("/widgets/delete/:id", async ({ api, assert, flash, req, res }) => {
      const { id } = req.params;
      assert(
        id,
        400,
        i18n.t("coaching-portal:widgetsActions.widgetIdRequired")
      );
      assert(
        id !== "undefined",
        400,
        i18n.t("coaching-portal:widgetsActions.widgetIdRequired")
      );

      const response = await api(`widget/${id}`, {
        method: "DELETE",
        body: { id },
      });

      const { ok, statusText = undefined } = response;

      if (!ok) {
        const errorMessage =
          statusText ||
          i18n.t("coaching-portal:widgetsActions.errorOccurred");
        flash("error", errorMessage);
        return res.backDontScroll();
      }

      flash(
        "success",
        i18n.t("coaching-portal:widgetsActions.successfullyRemoved")
      );
      res.redirect("/coaching-portal/widgets");
    });
};

export default Widgets;
